import React from "react";
import close from "../assets/images/modal-close.svg";
import modaldecoration from "../assets/images/modal-decoration.svg";
import RealmTicketIcon from "../assets/images/realm-ticket.svg";

function stopPropagation(e) {
  e.stopPropagation();
}

function ModalCriteria({ toggleModal }) {
  return (
    <>
      <div
        className="modal-wappar modal-criteria"
        onClick={() => toggleModal()}
      >
        <div className="outer" onClick={stopPropagation}>
          <div className="inner">
            <div className="content">
              <div className="criteria-info">
                <h3 className="criteria-title">
                  Mocalist Registration Eligibility
                </h3>
                <div className="criteria-icon">
                  <img src={RealmTicketIcon} alt="Realm Ticket" />
                </div>
                <div className="criteria-des">
                  <p>
                    1. HOLD: Hold your Tokens and NFTs until the snapshot on{" "}
                    <strong>8 am (EST), 12 January 2023</strong>.
                  </p>
                  <p>
                    2. REGISTER: Register for your Realm Tickets at{" "}
                    <a
                      href="https://www.mocaverse.xyz/"
                      target="_blank"
                      title="Mocaverse"
                      rel="noreferrer"
                    >
                      www.mocaverse.xyz
                    </a>{" "}
                    from <strong>13-15 January 2023</strong>.
                  </p>
                  <p>3. AIRDROP: Receive an airdrop of Realm Tickets.</p>
                  <p className="txt-no-spacing-sm">
                    <strong>Notes:</strong>
                  </p>
                  <p className="txt-no-spacing-sm">
                    1 Realm Ticket = 1 entry for a Mocalist spot.
                  </p>
                  <p>Each wallet will only have 1 winning Realm Ticket.</p>
                  <p className="txt-md">
                    For more details on the Token and NFT criteria, and bonus
                    mechanism, please refer to our{" "}
                    <a
                      target="_blank"
                      href="https://medium.com/mocaverse/mocaverse-announces-full-eligibility-criteria-and-mocalist-registration-event-27fcbcdb77"
                      title="Medium article"
                      rel="noreferrer"
                    >
                      Medium article
                    </a>
                    .
                  </p>
                  <p className="txt-sm">
                    For more details, please refer to our{" "}
                    <a
                      target="_blank"
                      href="https://medium.com/mocaverse/mocaverse-announces-full-eligibility-criteria-and-mocalist-registration-event-27fcbcdb77"
                      title="Medium article"
                      rel="noreferrer"
                    >
                      Medium article
                    </a>
                    .
                  </p>
                </div>
              </div>
              <div className="close">
                <img
                  src={close}
                  alt="close"
                  className="close-btn-modal "
                  onClick={() => toggleModal()}
                />
              </div>
              <img src={modaldecoration} alt="" className="modal-decoration" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ModalCriteria;
